/*
 * @Author: 陈传勋 593837024@qq.com
 * @Date: 2021-12-01 10:22:31
 * @LastEditors: 陈传勋 593837024@qq.com
 * @LastEditTime: 2022-08-09 17:31:16
 * @FilePath: /xlian-web-platform/src/store/modules/version.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import $api from '@/api'
import { PLATFORM_CHANNEL, DELAY_PERIOD } from '@/store/constants'
import { PLATFORM_TYPE, RELEASE_VERSION, BIZ_TYPE } from '@/utils/constants'
import { getVersionConfig } from 'xlian-utils'

const getCurrVersionExist = async commit => {
  const data = await getVersionConfig({
    platformType: PLATFORM_TYPE,
    version: RELEASE_VERSION,
    bizType: BIZ_TYPE,
    env: process.env.VUE_APP_UTILS_ENV
  })
  // const res = await $api.getCurrentVersionExist({
  //   platformType: PLATFORM_TYPE,
  //   version: RELEASE_VERSION,
  //   bizType: PLATFORM_CHANNEL.COE_ENTERPRISE
  // })

  const isCurrentVersion = !!data.url

  commit('SET_IS_CURR_VERSION', isCurrentVersion)
  commit('SET_VERSION_DAY', data?.versionDay)
}

const state = {
  isCurrentVersion: false,
  versionTaskId: null,
  versionDay: null
}

const mutations = {
  SET_IS_CURR_VERSION: (state, isCurrentVersion) => {
    state.isCurrentVersion = isCurrentVersion
  },
  SET_VERSION_ID: (state, versionTaskId) => {
    state.versionTaskId = versionTaskId
  },
  SET_VERSION_DAY: (state, versionDay) => {
    state.versionDay = versionDay
  }
}

const actions = {
  async startListenVersionChange({ commit }) {
    if (!state.isCurrentVersion) {
      await getCurrVersionExist(commit)
    }
    const taskId = setInterval(() => {
      getCurrVersionExist(commit)
    }, DELAY_PERIOD)
    if (state.versionTaskId) {
      clearInterval(state.versionTaskId)
    }
    commit('SET_VERSION_ID', taskId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
